export default (pathname: string, allowedPaths: string[] | undefined) => {
  if (pathname === '/') {
    return false;
  }

  return !!allowedPaths?.includes(pathname);
};
